module.exports = __webpack_public_path__ + "img/hipercard.688ff29f.svg";